module.exports = __webpack_public_path__ + "static/media/materials_ru.5c9cbd52.png";